import initialStateLoader from 'redux/initialState';
import AuthService from 'services/AuthService';

import { setError, setLoading, setLoggedIn } from './status';

import { fallbackError } from 'utilities/errorHandling';

const auth = new AuthService();
const defaultState = initialStateLoader().auth.sms;

/* Action Types
========================================================================== */
export const CHALLENGE_BEGIN_START = 'auth/sms/challenge/START';
export const CHALLENGE_BEGIN_SUCCESS = 'auth/sms/challenge/SUCCESS';
export const CHALLENGE_BEGIN_FAILURE = 'auth/sms/challenge/FAILURE';
export const CHALLENGE_RESOLVE_START = 'auth/sms/resolve/START';
export const CHALLENGE_RESOLVE_SUCCESS = 'auth/sms/resolve/SUCCESS';
export const CHALLENGE_RESOLVE_FAILURE = 'auth/sms/resolve/FAILURE';

/* Reducer | Default Export
========================================================================== */
const reducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case CHALLENGE_BEGIN_START:
      return {
        ...state,
        tryCount: state.tryCount + 1
      };

    case CHALLENGE_BEGIN_SUCCESS:
      return {
        ...state,

        activationCode: payload.activation_code,
        challengeID: payload.challengeId,
        step: 'respond'
      };

    case CHALLENGE_BEGIN_FAILURE:
      return { ...state, activationCode: null, challengeID: null };

    case CHALLENGE_RESOLVE_SUCCESS:
      return {
        ...state,

        activationCode: null,
        challengeID: null,
        step: 'begin'
      };

    default:
      return state;
  }
};

export default reducer;

/* Side Effects
========================================================================== */
export const beginSMSChallenge = (number, setFieldError) => dispatch => {
  const upgradeAppError = /upgrade your app/g;
  dispatch({ type: CHALLENGE_BEGIN_START });
  dispatch(setLoading(true));

  return auth
    .beginSMSChallenge(number)
    .then(response => {
      if (response && upgradeAppError.test(response.activation_code)) {
        throw new Error();
      }

      dispatch(setError(null));
      dispatch(setLoading(false));
      dispatch({ type: CHALLENGE_BEGIN_SUCCESS, payload: response });
    })
    .catch(err => {
      const message = err.error ? err.error : fallbackError();

      dispatch(setLoading(false));
      dispatch(setError(message));
      setFieldError('number', message);
      dispatch({
        type: CHALLENGE_BEGIN_FAILURE,
        payload: { error: message }
      });
    });
};

export const resolveSMSChallenge = (
  code,
  challengeID,
  persist,
  setFieldError
) => dispatch => {
  dispatch({ type: CHALLENGE_RESOLVE_START });
  dispatch(setLoading(true));

  return auth
    .resolveSMSChallenge(code, challengeID, persist)
    .then(response => {
      dispatch(setLoggedIn(true));
      dispatch(setError(null));
      dispatch(setLoading(false));
      dispatch({ type: CHALLENGE_RESOLVE_SUCCESS, payload: response });
    })
    .catch(err => {
      const message = err.error ? err.error : err.message;

      dispatch(setLoading(false));
      dispatch(setError(message));
      setFieldError('pin', message);
      dispatch({
        type: CHALLENGE_RESOLVE_FAILURE,
        payload: { error: message }
      });
    });
};

/* Selectors
========================================================================== */
export const getActivationCode = state => state.auth.sms.activationCode;
export const getChallengeID = state => state.auth.sms.challengeID;
export const getStep = state => state.auth.sms.step;
export const getTryCount = state => state.auth.sms.tryCount;
